export const faqs = [
  {
    question: "番茄漫画是免费的吗？",
    answer: "是的！番茄漫画是一个完全免费的漫画阅读平台。所有漫画内容均可免费在线阅读，无需付费订阅。我们致力于为广大漫画爱好者提供优质的免费阅读体验，让每个人都能轻松享受漫画的乐趣。",
  },
  {
    question: "支持哪些类型的漫画？",
    answer: "番茄漫画涵盖韩漫、日漫、国漫等多种类型，包括恋爱、热血、奇幻、搞笑、悬疑、科幻、修仙等多个题材。无论你喜欢哪种风格的漫画，都能在番茄漫画找到心仪的作品。我们每天都会更新最新的热门漫画资源。",
  },
  {
    question: "如何离线下载漫画？",
    answer: "番茄漫画支持离线下载功能。在漫画详情页点击「下载」按钮，即可将漫画章节缓存到本地设备。下载后的漫画可以在无网络环境下随时阅读，非常适合在地铁、飞机等网络不稳定场景使用。下载的漫画会自动保存在您的设备中。",
  },
  {
    question: "漫画多久更新一次？",
    answer: "番茄漫画的更新频率取决于漫画本身的连载进度。热门连载漫画通常每周更新1-2话，部分高人气作品可能实现日更。您可以在漫画详情页查看具体的更新日历，也可以开启「追更提醒」功能，第一时间获取最新话更新通知。",
  },
  {
    question: "如何搜索我想看的漫画？",
    answer: "您可以通过首页顶部的搜索框直接搜索漫画名称、作者或标签。也可以浏览分类页面，按韩漫、日漫、国漫或按恋爱、热血、奇幻等题材进行筛选。我们还在持续优化推荐算法，根据您的阅读偏好为您推荐可能喜欢的漫画。",
  },
  {
    question: "支持哪些设备阅读？",
    answer: "番茄漫画支持手机、平板和电脑等多种设备访问。我们的网站采用响应式设计，能够自动适配不同屏幕尺寸，在手机端、平板端和PC端都能获得流畅舒适的阅读体验。只需一个浏览器，随时随地畅享漫画世界。",
  },
  {
    question: "如何联系客服或反馈问题？",
    answer: "您可以通过「关于我们」页面的联系方式与我们取得联系，包括电子邮箱和在线客服。如果您在使用过程中遇到任何问题，或者有好的建议和意见，都欢迎随时反馈给我们。我们会在24小时内回复您的留言。",
  },
];

export const aboutInfo = {
  brandIntro: {
    title: "关于番茄漫画",
    content: "番茄漫画成立于2024年，是国内领先的免费漫画在线阅读平台。我们致力于打造一个高品质、多元化的漫画阅读社区，为全球华语漫画爱好者提供最优质的阅读体验。",
    mission: "让每个人都能轻松享受到漫画带来的快乐与感动",
    vision: "成为全球最大的华语漫画在线阅读平台",
  },
  features: [
    {
      icon: "ri-book-open-line",
      title: "海量资源",
      description: "收录超过10万部韩漫、日漫、国漫作品，涵盖恋爱、热血、奇幻、搞笑、悬疑等全品类题材，满足不同读者的阅读需求。",
    },
    {
      icon: "ri-download-line",
      title: "离线下载",
      description: "支持漫画章节离线缓存下载，无需网络也能畅快阅读。地铁上、飞机上、旅途中，漫画随时随地想看就看。",
    },
    {
      icon: "ri-flashlight-line",
      title: "极速更新",
      description: "与各大漫画平台同步更新，热门连载漫画第一时间推送最新话。追更不等待，精彩不错过。",
    },
    {
      icon: "ri-smartphone-line",
      title: "多端适配",
      description: "完美适配手机、平板、电脑等多种设备，自动响应式布局确保最佳阅读体验，随时随地畅享漫画世界。",
    },
  ],
  stats: [
    { value: "10万+", label: "漫画资源" },
    { value: "500万+", label: "月活用户" },
    { value: "98%", label: "用户好评率" },
    { value: "24h", label: "极速更新" },
  ],
  reviews: [
    {
      name: "小明同学",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%20with%20friendly%20smile%2C%20casual%20style%2C%20clean%20studio%20background&width=80&height=80&seq=avatar-01&orientation=squarish",
      rating: 5,
      comment: "番茄漫画真的太好用了！资源超全，更新也很快，我追的好几部韩漫都在这里找到。界面简洁清爽，阅读体验一级棒！",
      date: "2026-07-28",
    },
    {
      name: "漫画迷小美",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20natural%20look%2C%20clean%20studio%20background&width=80&height=80&seq=avatar-02&orientation=squarish",
      rating: 5,
      comment: "国漫资源特别丰富，很多新番都能第一时间看到。离线下载功能也很实用，通勤路上再也不怕没网了。强烈推荐！",
      date: "2026-07-25",
    },
    {
      name: "二次元阿杰",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20man%20with%20glasses%20portrait%2C%20friendly%20expression%2C%20casual%20hoodie%2C%20clean%20studio%20background&width=80&height=80&seq=avatar-03&orientation=squarish",
      rating: 5,
      comment: "作为资深日漫迷，番茄漫画的日漫资源让我非常惊喜。不仅有热门连载，还有很多经典完结作品，分类清晰找起来很方便。",
      date: "2026-07-22",
    },
    {
      name: "追更达人",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20woman%20portrait%20with%20energetic%20smile%2C%20casual%20style%2C%20clean%20studio%20background&width=80&height=80&seq=avatar-04&orientation=squarish",
      rating: 4,
      comment: "追更提醒功能太贴心了！再也不会错过喜欢漫画的更新。而且页面加载很快，阅读流畅不卡顿，给开发团队点赞！",
      date: "2026-07-20",
    },
  ],
  contact: {
    email: "contact@fanqiecomic.com",
    wechat: "番茄漫画官方",
    weibo: "@番茄漫画官方微博",
    address: "广东省广州市天河区体育西路111号番茄大厦18层",
    phone: "400-888-6666",
  },
};